import apiClient from "../http/apiClient";
import { CUSTOMER_ENDPOINTS } from "../http/endpoints";

const customerDetailUrl = (id) => `${CUSTOMER_ENDPOINTS.customers}${id}/`;
const customerContactsUrl = (id) => `${CUSTOMER_ENDPOINTS.customers}${id}/${CUSTOMER_ENDPOINTS.customerContactsSuffix}`;
const customerContactDetailUrl = (customerId, contactId) => `${customerContactsUrl(customerId)}${contactId}/`;

export async function listCustomers(params = {}) {
  const response = await apiClient.get(CUSTOMER_ENDPOINTS.customers, { params });
  return response.data;
}

export async function getCustomer(id) {
  const response = await apiClient.get(customerDetailUrl(id));
  return response.data;
}

export async function createCustomer(payload) {
  const response = await apiClient.post(CUSTOMER_ENDPOINTS.customers, payload);
  return response.data;
}

export async function updateCustomer(id, payload) {
  const response = await apiClient.patch(customerDetailUrl(id), payload);
  return response.data;
}

export async function findCustomerByPhone(phoneNumber) {
  const response = await apiClient.get(CUSTOMER_ENDPOINTS.customersByPhone, {
    params: { phone_number: phoneNumber },
  });
  return response.data;
}

export async function listContacts(customerId, params = {}) {
  const response = await apiClient.get(customerContactsUrl(customerId), { params });
  return response.data;
}

export async function createContact(customerId, payload) {
  const response = await apiClient.post(customerContactsUrl(customerId), payload);
  return response.data;
}

export async function updateContact(customerId, contactId, payload) {
  const response = await apiClient.patch(customerContactDetailUrl(customerId, contactId), payload);
  return response.data;
}

export const customersService = {
  list: listCustomers,
  get: getCustomer,
  create: createCustomer,
  update: updateCustomer,
  findByPhone: findCustomerByPhone,
  listContacts,
  createContact,
  updateContact,
};

export default customersService;
